import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-24 -md:pt-16 p-5" }
const _hoisted_2 = { class: "px-6 py-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Meu Cadastro", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmFormData = _resolveComponent("ConfirmFormData")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_ConfirmFormData, { class: "shadow-xl" })
    ])
  ]))
}